import { Immutable } from "immer";
import React from "react";

import { templates } from "@reactivated";

import { ProductModulesBody } from "../productModulesBody";

/**
 * toppers ProductLinePage ``modules`` body assembly entry point.
 *
 * Null-guards the ``page.modules`` StreamField (a bodyless page renders
 * nothing) and dispatches the body through ``ProductLinePageBody``, threading
 * the five id-keyed SSR side-channels (``reviews`` / ``change_variant_ssr`` /
 * ``change_root_ssr`` / ``root_conditional_ssr`` / ``variant_conditional_ssr``)
 * plus the page-level ``page_num_reviews`` count that gates the reviews_full CTA.
 */
export const ProductLinePageBody = (
    props: Immutable<
        Pick<
            templates.ProductLinePageTemplate,
            | "page"
            | "reviews"
            | "page_num_reviews"
            | "change_variant_ssr"
            | "change_root_ssr"
            | "root_conditional_ssr"
            | "variant_conditional_ssr"
        >
    >,
): React.JSX.Element | null => {
    const modules = props.page.modules;
    if (!modules) {
        return null;
    }
    return (
        <ProductModulesBody
            value={modules.value}
            reviews={props.reviews}
            pageNumReviews={props.page_num_reviews}
            changeVariantSSR={props.change_variant_ssr}
            changeRootSSR={props.change_root_ssr}
            rootConditionalSSR={props.root_conditional_ssr}
            variantConditionalSSR={props.variant_conditional_ssr}
        />
    );
};
